import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Util from 'root/module/util';
import Constants from 'root/constants';
import Cache from 'root/cache';
import View from 'view/base';

const inbox_modes = {
    on: ['Default', 'Userback\'s recommended settings'],
    important: ['Focus mode', 'Keep track of work without attention overload'],
    off: ['Silent', 'Turn notifications off']
};

export default View.extend({
    tab: 'email',
    inbox_filters: {},

    events: {
        'click .dropdown-project li'    : 'onSelectProject',
        'click .dropdown-inbox-mode li' : 'onSelectInboxMode',
        'click .notification-toggle'    : 'onToggleNotification'
    },

    dom_handlers: {
        onSelectProject: function(e) {
            if ($(e.currentTarget).hasClass('disabled')) {
                return;
            }

            var project_id = parseInt($(e.currentTarget).data('val'), 10);
            var action     = $(e.currentTarget).data('type');

            if (this.hasNotification(action, project_id)) {
                $(e.currentTarget).removeClass('selected');

                Cache.app.request({
                    action: 'notification/delete',
                    data: {
                        project_id  : project_id,
                        user_id     : this.user_id,
                        action_type : action,
                        type        : 'email'
                    },
                    success: () =>{
                        this.email_notifications.forEach((notification, index) => {
                            if (notification.action === action && notification.project_id === project_id) {
                                this.email_notifications.splice(index, 1);
                            }
                        });

                        UI.success('Notification turned off');
                        this.$el.find('.region-projects[data-type="' + action + '"] button.dropdown-select').html(this.renderProjectSelection(action));
                    }
                });
            } else {
                $(e.currentTarget).addClass('selected');

                Cache.app.request({
                    action: 'notification/create',
                    data: {
                        project_ids : [project_id],
                        user_id     : this.user_id,
                        action_type : action,
                        type        : 'email'
                    },
                    success: (response) => {
                        response.forEach((notification) => {
                            this.email_notifications.push(notification);
                        });

                        UI.success('Notification turned on');
                        this.$el.find('.region-projects[data-type="' + action + '"] button.dropdown-select').html(this.renderProjectSelection(action));
                    }
                });
            }
        },

        onSelectInboxMode: function(e) {
            var project_id = parseInt($(e.currentTarget).closest('.dropdown-inbox-mode').data('val'), 10);
            var mode = $(e.currentTarget).data('val');
            var text = inbox_modes[mode][0];

            $(e.currentTarget).addClass('selected').siblings().removeClass('selected');
            $(e.currentTarget).closest('.dropdown-inbox-mode').children('button').text(text);

            var projects = this.inbox_filters && this.inbox_filters.projects ? this.inbox_filters.projects : {};

            if (mode === 'on') {
                // when a project doesn't have the inbox mode set, it will use the default mode
                // that way, we won't have to add inbox mode for new projects
                delete projects[project_id];
            } else {
                projects[project_id] = mode;
            }

            this.inbox_filters.projects = projects;

            // save filter
            Cache.app.addUserSetting('inbox_filter', JSON.stringify(this.inbox_filters), false);

            UI.success('Inbox notification settings updated');
        },

        onToggleNotification: function(e) {
            var action = $(e.currentTarget).data('val');

            if ($(e.currentTarget).hasClass('switch-on')) {
                $(e.currentTarget).addClass('switch-off').removeClass('switch-on');

                Cache.app.request({
                    action: 'notification/delete',
                    data: {
                        project_id  : 0,
                        user_id     : this.user_id,
                        action_type : action,
                        type        : 'email'
                    },
                    context: this,
                    success: function() {
                        this.email_notifications.forEach((notification, index) => {
                            if (notification.action === action) {
                                this.email_notifications.splice(index, 1);
                            }
                        });

                        UI.success('Notification turned off');
                    }
                });

            } else {
                $(e.currentTarget).addClass('switch-on').removeClass('switch-off');

                Cache.app.request({
                    action: 'notification/create',
                    data: {
                        project_ids : [0],
                        user_id     : this.user_id,
                        action_type : action,
                        type        : 'email'
                    },
                    context: this,
                    success: function(response) {
                        response.forEach((notification) => {
                            this.email_notifications.push(notification);
                        });

                        UI.success('Notification turned on');
                    }
                });
            }
        }
    },

    loadNotification: function() {
        Cache.app.request({
            action: 'notification/load',
            data: {
                user_id: this.user_id
            },
            context: this,
            success: function(response) {
                this.email_notifications = response;
                this.render();
            }
        });
    },

    initialize: function(options) {
        this.user_id = options.user_id;
        this.tab = options.tab;
        this.show_inbox = !!options.show_inbox;

        if (!Cache.account.hasFeature('inbox')) {
            this.tab = 'email';
            this.show_inbox = false;
        }

        try {
            this.inbox_filters = JSON.parse(Cache.app.getUserSetting('inbox_filter', false)) || {};
        } catch (e) {
            this.inbox_filters = {};
        }
    },

    hasNotification: function(action, project_id) {
        var result = false;

        this.email_notifications.forEach((notification) => {
            if (notification.action === action && notification.project_id === project_id) {
                result = true;
            }
        });

        return result;
    },

    getProjectBadge: function(project_model, action) {
        var html =
        '<span class="badge-primary-invert badge-btn margin-right-4 margin-top-4">' +
            Util.htmlEntities(Util.trim(project_model.get('name'), 40)) +
            '<button type="button" class="project-delete" data-val="' + project_model.id + '" data-type="' + action + '"><i class="far fa-times"></i></button>' +
        '</span>';

        return html;
    },

    filterProjects: function(action) {
        var projects = Cache.project.where({is_archived: false});
        var project_items = '';
        var active_ids = [];
        var selected_projects = [];

        var project_type = action === 'survey_create' ? 'survey' : 'feedback';

        this.email_notifications.forEach((notification) => {
            if (notification.action === action) {
                active_ids.push(notification.project_id);
            }
        });

        projects.forEach((model) => {
            var has_access = false;
            var member = Cache.workspace_member.filter({user_id: this.user_id});

            if (member.length === 0) {
                return;
            }

            if (member[0].get('role') === Constants.ADMIN) {
                has_access = true;
            } else if (Cache.project_access.where({project_id: model.id, user_id: this.user_id}).length) {
                has_access = true;
            }

            if (!Cache.account.hasFeature('user_restriction')) {
                has_access = true;
            }

            if (!has_access) {
                return;
            }

            if (project_type === 'survey' && !model.isSurvey()) {
                return;
            }

            if (project_type === 'feedback' && !model.isFeedback()) {
                return;
            }

            if (active_ids.indexOf(model.id) !== -1) {
                selected_projects.push(model);
            }

            project_items += '<li data-val="' + model.id + '" data-type="' + action + '"' + (active_ids.indexOf(model.id) !== -1 ? ' class="selected"' : '') + '>' + model.escape('name') + '</li>';
        });

        return {
            selected_projects: selected_projects,
            project_items: project_items
        };
    },

    renderProjectSelection: function(action) {
        var filtered_projects = this.filterProjects(action);
        var selected_projects = filtered_projects.selected_projects;

        if (selected_projects.length === 0) {
            return '<span class="placeholder-text">Select...</span>';
        } else if (selected_projects.length <= 2) {
            return selected_projects.map((project) => {
                return '<span class="badge-primary-invert badge-small">' + Util.htmlEntities(Util.trim(project.get('name'), 40)) + '</span>';
            }).join('');
        } else {
            return selected_projects.length + ' projects';
        }
    },

    renderProjects: function(action) {
        var projects = Cache.project.where({is_archived: false});
        var filtered_projects = this.filterProjects(action);
        var project_items = filtered_projects.project_items;

        var html =
        '<div class="button-dropdown button-dropdown-full button-dropdown-large" data-flip="true" data-append="true" data-addscroll="true" data-autoclose="false">' +
            '<button type="button" class="dropdown-select dropdown-select-medium dropdown-select-multiple">' +
                this.renderProjectSelection(action) +
            '</button>' +
            '<div>' +
                (projects.length > 1 ?
                '<div class="dropdown-search">' +
                    '<input type="text" class="solid compact" placeholder="Search by project name">' +
                '</div>' : '') +
                '<ul class="dropdown dropdown-select dropdown-project">' +
                    (!project_items ?
                    '<li class="disabled">This user has access to 0 projects</li>' : '') +
                    project_items +
                '</ul>' +
            '</div>' +
        '</div>';

        return html;
    },

    render: function() {
        var project_settings = this.inbox_filters && this.inbox_filters.projects ? this.inbox_filters.projects : {};

        var content =
        '<div class="tab">' +
            (this.show_inbox ?
            '<div class="tab-menu">' +
                '<a href="#"' + (this.tab === 'inbox' ? ' class="active"' : '') + '>Inbox Notifications</a>' +
                '<a href="#"' + (this.tab === 'email' ? ' class="active"' : '') + '>Email Notifications</a>' +
            '</div>' : '') +
            '<div class="tab-content">' +
                '<div' + (this.tab === 'inbox' ? ' class="active"' : '') + '>' +
                    '<p>Manage your inbox notifications for individual projects. <a href="https://support.userback.io/en/articles/6673045" class="primary font-weight-medium" target="help" rel="noopener">Learn more <i class="fa-solid fa-square-arrow-up-right"></i></a></p>' +
                    '<hr class="small">' +
                    Cache.project.where({is_archived: false}).map((project) => {
                        var project_inbox_mode = (project_settings[project.id] && inbox_modes[project_settings[project.id]][0] ? inbox_modes[project_settings[project.id]][0] : 'Default');

                        return '' +
                        '<div class="grid-9-3">' +
                            '<div class="flex-start overflow-hidden margin-right-24">' +
                                (project.get('logo') ?
                                '<span class="project-logo-icon-small" style="background-image:url(' + project.escape('logo') + ');"></span>' :
                                '<span class="project-type-icon-small" data-val="' + (project.isFeedback() ? 'feedback' : 'survey') +'"></span>') +
                                '<span class="margin-left-8 ellipsis">' + project.escape('name') + '</span>' +
                            '</div>' +
                            '<div class="text-align-right">' +
                                '<div class="button-dropdown button-dropdown-xlarge button-dropdown-full dropdown-inbox-mode" data-val="' + project.id + '">' +
                                    '<button type="button" class="dropdown-select">' + project_inbox_mode + '</button>' +
                                    '<div>' +
                                        '<ul class="dropdown dropdown-select">' +
                                            _.map(inbox_modes, (mode, key) => {
                                                var project_mode = project_settings[project.id] ? project_settings[project.id] : 'on';

                                                return '' +
                                                '<li data-val="' + key + '"' + (key === project_mode ? ' class="selected"' : '') + '>' +
                                                    '<div class="font-weight-medium">' + mode[0] + '</div>' +
                                                    '<div class="desc-text">' + mode[1] + '</div>' +
                                                '</li>';
                                            }).join('') +
                                        '</ul>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                        '<hr class="small">'
                    }).join('') +
                    (Cache.project.where({is_archived: false}).length === 0 ?
                    '<div class="text-info italic">No projects found.</div>' : '') +
                '</div>' +
                '<div' + (this.tab === 'email' ? ' class="active"' : '') + '>' +
                    '<p>The notification emails are sent to the user email <span class="font-weight-semibold">' + Cache.user.get(this.user_id).escape('email') + '</span>.</p>' +
                    '<hr class="small">' +

                    (this.email_notifications ?
                    '<div>When <b>new feedback</b> is received in the selected projects</div>' +
                    '<div class="region-projects margin-top-8" data-type="feedback_create">' + this.renderProjects('feedback_create') + '</div>' +

                    '<div class="divider-24"></div>' +

                    '<div>When an <b>idea is voted</b> in the selected projects</div>' +
                    '<div class="region-projects margin-top-8" data-type="feedback_vote">' + this.renderProjects('feedback_vote') + '</div>' +

                    '<hr class="medium">' +

                    '<div class="grid-10-2 line-height-20">' +
                        '<div>Someone <b>@mentions me</b> in any comments</div>' +
                        '<div class="text-align-right"><button type="button" class="notification-toggle ' + (this.hasNotification('mention', 0) ? 'switch-on' : 'switch-off') + ' small v-align-top" data-val="mention"></button></div>' +
                    '</div>' +

                    '<div class="divider-8"></div>' +

                    '<div class="grid-10-2 line-height-20">' +
                        '<div>Someone <b>responds</b> to my comments</div>' +
                        '<div class="text-align-right"><button type="button" class="notification-toggle ' + (this.hasNotification('reply', 0) ? 'switch-on' : 'switch-off') + ' small v-align-top" data-val="reply"></button></div>' +
                    '</div>' +

                    '<div class="divider-8"></div>' +

                    '<div class="grid-10-2 line-height-20">' +
                        '<div>Someone <b>assigns me</b> a feedback</div>' +
                        '<div class="text-align-right"><button type="button" class="notification-toggle ' + (this.hasNotification('assign', 0) ? 'switch-on' : 'switch-off') + ' small v-align-top" data-val="assign"></button></div>' +
                    '</div>' +

                    '<hr class="medium">' +

                    '<div class="margin-bottom-4"><b>My feedback:</b></div>' +
                    '<div class="margin-bottom-16 text-info text-medium">For feedback reported by me, assigned to me or followed by me</div>' +

                    '<div class="grid-10-2 line-height-20">' +
                        '<div>Someone comments without @mentioning me</b></div>' +
                        '<div class="text-align-right"><button type="button" class="notification-toggle ' + (this.hasNotification('my_feedback_comment', 0) ? 'switch-on' : 'switch-off') + ' small v-align-top" data-val="my_feedback_comment"></button></div>' +
                    '</div>' +

                    '<div class="divider-8"></div>' +

                    '<div class="grid-10-2 line-height-20">' +
                        '<div>Status or Assignee is changed</div>' +
                        '<div class="text-align-right"><button type="button" class="notification-toggle ' + (this.hasNotification('my_feedback_change', 0) ? 'switch-on' : 'switch-off') + ' small v-align-top" data-val="my_feedback_change"></button></div>' +
                    '</div>' +

                    (Cache.account.hasFeature('survey') ?
                    '<hr class="medium">' +
                    '<div class="margin-bottom-4"><b>Survey:</b></div>' +
                    '<div>When <b>new response</b> is received in the selected surveys</div>' +
                    '<div class="region-projects margin-top-8" data-type="survey_create">' + this.renderProjects('survey_create') + '</div>' : '')

                    :

                    '<div class="loader-placeholder margin-bottom-12" style="width:100px;"></div>' +
                    '<div class="loader-placeholder margin-bottom-20"></div>' +
                    '<div class="loader-placeholder margin-bottom-12" style="width:100px;"></div>' +
                    '<div class="loader-placeholder margin-bottom-20"></div>' +

                    '<hr class="medium">' +

                    '<div class="loader-placeholder margin-bottom-12" style="width:300px;"></div>' +
                    '<div class="loader-placeholder margin-bottom-12" style="width:280px;"></div>' +
                    '<div class="loader-placeholder margin-bottom-12" style="width:260px;"></div>' +

                    '<hr class="medium">' +

                    '<div class="loader-placeholder margin-bottom-12" style="width:300px;"></div>' +
                    '<div class="loader-placeholder margin-bottom-12" style="width:220px;"></div>') +
                '</div>' +
            '</div>' +
        '</div>';

        if (!this.email_notifications) {
            this.loadNotification();
        }

        this.$el.html(content);

        return this;
    }
});